"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PAGE = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var PagingSizeSelector_1 = __importDefault(require("./PagingSizeSelector/PagingSizeSelector"));
var PageButtonList_component_1 = __importDefault(require("./PageButtonList/PageButtonList.component"));
var Styled = __importStar(require("./Pagination.styled"));
exports.FIRST_PAGE = 1;
var Pagination = function (_a) {
    var pageOptions = _a.pageOptions, selectableSize = _a.selectableSize, handleChangePage = _a.handleChangePage;
    var currentPage = pageOptions.currentPage, startPage = pageOptions.startPage, endPage = pageOptions.endPage, totalPages = pageOptions.totalPages, pagingSize = pageOptions.pagingSize;
    return ((0, jsx_runtime_1.jsxs)(Styled.Navigation, __assign({ "aria-label": "Pagination" }, { children: [(0, jsx_runtime_1.jsx)(Styled.Box, { width: "16rem" }, void 0), (0, jsx_runtime_1.jsx)(Styled.PageButtonListWrapper, { children: (0, jsx_runtime_1.jsx)(PageButtonList_component_1.default, { currentPage: currentPage, startPage: startPage, endPage: endPage, totalPages: totalPages, handleChangePage: handleChangePage }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(Styled.Box, __assign({ width: "16rem" }, { children: selectableSize && ((0, jsx_runtime_1.jsx)(PagingSizeSelector_1.default, { pagingSize: pagingSize, position: selectableSize.selectBoxPosition, handleChangeSize: selectableSize.handleChangeSize }, void 0)) }), void 0)] }), void 0));
};
exports.default = Pagination;
